import Dexie from "dexie";
import { v1 as uuidv1 } from "uuid";
import eventEmitter from "../event-emitter";

/**
 * @description: Class - 添加记录
 * @return {*}
 */
export class LogRecord extends Dexie {
  static #_instance;
  logs;
  /**
   * @description: 初始化 Monitor，如果已经存在实例，就直接返回实例，如果不存在，则实例化后返回
   * @param {*} options
   * @return {*}
   */
  static getInstance(options) {
    if (!LogRecord.#_instance) {
      LogRecord.#_instance = new LogRecord(options);
    }
    return LogRecord.#_instance;
  }
  /**
   * @description: 在 _instance 已经生成的情况下直接获取实例
   * @return {*}
   */
  static getDiretcInstance() {
    if (!LogRecord.#_instance) {
      throw new Error("尚未初始化 LogRecord 类");
    }
    return LogRecord.#_instance;
  }

  constructor(options) {
    const { dbName } = options;
    // 数据库名称 - 建立数据库
    super(dbName);
    // 定义结构表
    this.version(1).stores({
      logs: "&id, eventLevel, eventType, eventTime, eventDetail",
    });
  }

  /**
   * @description: 新增一条记录
   * @param {*} data
   * @example
   *  data: {
   *    eventLevel: 'info' | 'warn' | 'error'
   *    eventType: string
   *    eventDetail: string
   *    ext?: string
   *  }
   */
  async addRecord(data) {
    const eventTime = Date.now();
    const recordData = {
      ...data,
      eventTime,
      id: uuidv1(eventTime),
      localtion_origin: window.location.origin,
      location_path: window.location.href,
      screen: `w_${window.screen.width},h_${window.screen.height}`,
      window: `w_${window.innerWidth},h_${window.innerHeight}`,
    };
    this.logs.add(recordData).catch((err) => {
      eventEmitter.emit("LogRecord_Error_Add", {
        data,
        errMsg: "LogRecord_Error_Add:" + err.message,
      });
      if (err.message.includes("QuotaExceededError")) {
        eventEmitter.emit("LogRecord_QuotaExceededError_Storage");
      }
    });
  }

  /**
   * @description: 删除一条记录
   * @param {string} id
   * @return {*}
   */
  async deleteRecord(id) {
    await this.logs.delete(id);
  }

  /**
   * @description: 删除多条记录
   * @param {string[]} ids
   * @return {*}
   */
  async bulkDeleteRecord(ids) {
    await this.logs.bulkDelete(ids);
  }

  /**
   * @description: 根据 eventTime 降序排序给出日志记录
   * @return {*}
   */
  async getRecords() {
    const result = await this.logs.orderBy("eventTime").reverse().toArray();
    return result;
  }

  /**
   * @description: 清空数据
   */
  async clearLogTable() {
    await this.logs.clear();
  }

  /**
   * @description: 获取可用存储空间
   * @return {*}
   */
  async getEstimatedQuota() {
    if (navigator && navigator.storage && navigator.storage.estimate) {
      const estimation = await navigator.storage.estimate();
      return {
        quota: estimation.quota || 0,
        usage: estimation.usage || 0,
      };
    } else {
      return {
        quota: "--",
        usage: "--",
      };
    }
  }
}
